import {OnBoardingTooltipModel} from "../on-boarding-tooltip.model";

import {IOnBoardingTooltipsContainer} from "../on-boarding-tooltips-container.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {TimeSpan} from "@sparkware/app-utils";
import {IconTitleTextTooltip} from "../../../../components/tooltip/tooltips/icon-title-text/icon-title-text.tooltip";
import React from "react";
import {
    TOOLTIP_TARGET_HEADER_BANKROLL_BUTTON_MOBILE,
    TOOLTIP_TARGET_FREE_PLAY_INDICATOR,
    TOOLTIP_TARGET_GIFT_MINI_ORBIT_INDICATOR
} from "../on-boarding-tooltip-target-selectors";
import {CyClass} from "../../../../../common/cy-classes";
import {makeObservable} from "mobx";

export class FreePlayOnBoardingTooltipModel extends OnBoardingTooltipModel {

    constructor(tooltipsContainer: IOnBoardingTooltipsContainer,
                services: IServiceFactoryExtended) {

        super(tooltipsContainer, services, {
            renderContent: () => (<IconTitleTextTooltip icon={services.theme.currentTheme.assets.images.tooltip.gift_svg.toString()}
                                                        title={services.translation.translate("CONGRATS")}
                                                        text={services.translation.translate("YOUR_FP_ARE_WAITING")}
                                                        onClick={this._onTooltipClicked}
                                                        className={CyClass('cy-free-play-on-boarding-tooltip')}/>),
            timeout: TimeSpan.fromSeconds(7),
            localStorageKey: 'free_play_on_boarding_tooltip',
            maximumDisplayCount: 5,
            showOverlay: true,
            showCloseButton: false,
            closeOnClickOutside: true,
            animated: true,
        });
        makeObservable(this);
    }

    shouldDisplay(): boolean {
        //we use separate variables to make sure that this method depends on all the observable involved in the condition
        const hasVouchers = this.services.freePlay.hasVouchers;
        const commonConditions = super.shouldDisplay();

        return hasVouchers && commonConditions;

    }

    protected _getElementToAttach(): HTMLElement| null {
        const mobileElement = this.services.dom.querySelector(`.${TOOLTIP_TARGET_HEADER_BANKROLL_BUTTON_MOBILE}`) as HTMLElement;

        if(mobileElement) {
            return mobileElement;
        }

        const pcElement = this.services.dom.querySelector(`.${TOOLTIP_TARGET_FREE_PLAY_INDICATOR}`) as HTMLElement;

        if(pcElement) {
            return pcElement;
        }

        // mini-orbit
        return this.services.dom.querySelector(`.${TOOLTIP_TARGET_GIFT_MINI_ORBIT_INDICATOR}`) as HTMLElement;
    }

    onToolTipRendered(tooltipContainer: HTMLElement) {
        super.onToolTipRendered(tooltipContainer);
        this.services.analytics.sendOrbitUserFlowEvent("Tooltip", "Show", "FP_Bubble");
    }


    private _onTooltipClicked = async () => {
        this.closeTooltip();
        if (this.services.miniOrbit.isEnabled) {
            this.services.miniOrbit.openFreePlays()
        } else {
            (await this.services.userMenu).openRewards();
        }
        this.services.analytics.sendOrbitUserFlowEvent("Tooltip", "Click", "FP_Bubble");
    }
}